<script lang="ts">
  import { componentLibrary } from '../../../store/componentLibrary';

  const {
    children,
    passThroughProps = {},
  }: {
    children: any;
    passThroughProps?: any;
  } = $props();
</script>

{#if Array.isArray(children)}
  <!-- A key expression is used with the entryId from BaseProps (or index if there is no entryId) so Svelte will be able
   to update the list when data changes https://svelte.dev/docs/svelte/each#Keyed-each-blocks -->
  {#each children as child, index (child?.props?.entryId ?? index)}
    {#if $componentLibrary[child.componentName]}
      {@const SvelteComponent = $componentLibrary[child.componentName]}
      <SvelteComponent {...child.props} {...passThroughProps} />
    {/if}
  {/each}
{:else if $componentLibrary[children.componentName]}
  {@const SvelteComponent = $componentLibrary[children.componentName]}
  <SvelteComponent {...children.props} {...passThroughProps} />
{/if}
